import { all, takeEvery, put, call } from 'redux-saga/effects'
import showBusinessTypes from 'services/common'
import actions from './actions'

export function* SHOW_BUSINES_TYPES() {
  yield put({
    type: 'common/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const response = yield call(showBusinessTypes)
  if (response) {
    const { business_types: bTypes } = response
    yield put({
      type: 'common/SET_BUSINES_TYPES',
      payload: {
        businessTypes: bTypes,
      },
    })
  }
  yield put({
    type: 'common/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export default function* rootSaga() {
  yield all([takeEvery(actions.SHOW_BUSINES_TYPES, SHOW_BUSINES_TYPES), SHOW_BUSINES_TYPES()])
}
